/**
 * TranslationSideBar: 자막/번역 사이드바 컨테이너.
 *
 * translation.isSettingMode === true → TranslationSettings
 * translation.isSettingMode === false → TranslationHistory
 *
 * 마크업:
 *  - 설정: translate_2.html `.new_chat.flexType`
 *  - 히스토리: translate_1.html `.new_chat.inst_tabs`
 */
import React from 'react';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { uiActions } from '@/store/slices/uiSlice';
import { translationActions } from '@/store/slices/translationSlice';
import TranslationSettings from './TranslationSettings';
import TranslationHistory from './TranslationHistory';

const TranslationSideBar: React.FC = () => {
  const dispatch = useAppDispatch();
  const isSettingMode = useAppSelector((s) => s.translation.isSettingMode);

  const handleClose = () => {
    dispatch(uiActions.setOpenSideBar(false));
  };

  const handleGoBack = () => {
    // 설정 패널에서 뒤로가기 → 히스토리 패널
    dispatch(translationActions.setSettingMode(false));
  };

  const handleOpenSettings = () => {
    dispatch(translationActions.setSettingMode(true));
  };

  if (isSettingMode) {
    // ── 설정 패널 (translate_2.html 패턴) ──
    return (
      <div className="new_chat flexType">
        <div className="chat_tabs">
          <div className="chat_selection inFlex">
            <button type="button" className="btnPrev" onClick={handleGoBack}>
              <span className="blind">이전</span>
            </button>
            <h2>자막/번역설정</h2>
          </div>
          <div className="right_btns">
            <button type="button" className="chat_closeBtn" onClick={handleClose}>
              <span className="blind">닫기</span>
            </button>
          </div>
        </div>
        <TranslationSettings />
      </div>
    );
  }

  // ── 히스토리 패널 (translate_1.html 패턴) ──
  return (
    <div className="new_chat inst_tabs">
      <div className="chat_tabs">
        <div className="chat_selection">
          <h2>자막 히스토리</h2>
        </div>
        <div className="right_btns">
          <div className="right_btns__item">
            <button type="button" className="chat_setting" onClick={handleOpenSettings}>
              <span className="blind">설정</span>
            </button>
          </div>
          <button type="button" className="chat_closeBtn" onClick={handleClose}>
            <span className="blind">닫기</span>
          </button>
        </div>
      </div>
      <TranslationHistory />
    </div>
  );
};

export default TranslationSideBar;
